export default __webpack_public_path__ + "static/media/logo138x75white.626b84ff.png";